import { styled } from "@mui/joy";

const Sidebar = styled("div")(({ theme }) => ({
  width: "360px",
  position: "relative",
  zIndex: 10,
  display: "flex",
  flexDirection: "column",
  height: "100%",
  overflow: "hidden",
  backgroundColor: theme.vars.palette.background.body,
}));

export const SidebarHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "0.5rem",
  borderBottom: `1px solid ${theme.vars.palette.divider}`,
  backgroundColor: theme.vars.palette.neutral["100"],
}));

export default Sidebar;
